export default __webpack_public_path__ + "static/media/GetGrowCart_Logo.0611bf87.jpg";